module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tile":"WeSaidSo Software Engineering"},"nl":{"tile":"WeSaidSo Software Engineering"}}')
  delete Component.options._Ctor
}
